/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import isPlainObject from"./isPlainObject";const isEmpty=function(t){if(!isPlainObject(t))return!1;for(var i in t)if(t.hasOwnProperty(i))return!1;return!0};export default isEmpty;